import { ColoursObj } from "@eventr/common-storybook";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { routes } from "routing";
import HitBoxIcon from "./HitBoxIcon";

export default function CarouselSeeAllItineraries({ colour = ColoursObj.shades.shade5 }: { colour?: string }) {
  const { pushPath } = useGlobalRouter();

  return (
    <HitBoxIcon
      // Tags the pushed view so the itineraries list knows it was reached from Home,
      // not the Account tab, and can pop back rather than switching tabs. Pushed through the
      // global router so that in two panes it opens as a sheet over the route it came from.
      id="carousel-see-all-itineraries"
      onClick={() =>
        pushPath(routes.itineraries.path, {
          animation: "none",
          state: { fromTab: "home" },
        })
      }
      icon="Hamburger"
      colour={colour}
    />
  );
}
